module.exports = __webpack_public_path__ + "media/images/fonts/HKGroteskPro/HKGroteskPro-Light-cc6eea5568cb0ed5f8366138404897e2.woff";